import GlobalBreadcrumbsMixin from "../../Mixins/GlobalBreadcrumbsMixin";
import ComponentMixin from "../../Mixins/ComponentMixin";

export default {
  mixins: [GlobalBreadcrumbsMixin, ComponentMixin],

  mounted () {
    this.setBreadcrumb(this.$t("payout.model"));
  },

  methods: {
    navigateToIndexRoute () {
      this.$router.push({
        name: "Revenues"
      });
    }
  }
};
